export default __webpack_public_path__ + "static/media/rob-head.5b802bf8.png";